module.exports = __webpack_public_path__ + "img/Newbie_Shield_03_Ranger.3abb633e.png";